import React from "react";

export const SkipPrevIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    height="48" 
    width="48"
    viewBox="0 0 46 46"
    {...props}
    >
    <path d="M11 36V12h3v24Zm26 0L19.7 24 37 12Zm-3-12Zm0 6.25v-12.5L24.95 24Z" />
  </svg>
);
